import { ITribe } from '@/contracts/TribeContract';
import { DataSource } from './abstract-data-source';
import { AbstractDataSourceType } from './abstract-data-source-type';

export interface TribeDataType extends AbstractDataSourceType, ITribe {

}

export class TribesDataSource extends DataSource {
  public data: TribeDataType[];

  constructor(tribes: ITribe[]) {
    super(tribes);
  }
}
